class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('.menu-drawer-container');
    this.summaryToggle = this.querySelector('.header__icon--menu');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"].button--close').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details')?.hasAttribute('open') || this.querySelector("#menu-drawer").classList.contains("open") ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    console.log("opening");
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details')?.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');
    if (this.querySelector("#Details-menu-drawer-container")) {
      console.log("opening");
      this.querySelector("#menu-drawer").classList.add("open");
      document.querySelector('.section-header').classList.add('menu-open');
      const closeButton = this.querySelector('.button--close');
      const container = this.detailsContainer.querySelector('.menu-drawer__inner-container');
      this.addEventListener('transitionend', (e) => {
        if (e.target != this.querySelector("#menu-drawer")) return;
        trapFocus(
          container,
          container
        );
      }, { once: true });
    } else {
      trapFocus(
        this.detailsContainer.querySelector('[tabindex="-1"]'),
        this.detailsContainer.querySelector('input:not([type="hidden"])')
      );
    }
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    if (this.querySelector("#Details-menu-drawer-container")) {
      this.querySelector("#menu-drawer").classList.remove("open");
    }
  }
}

customElements.define('details-modal', DetailsModal);
